module.exports = __webpack_public_path__ + "img/jingji2.bbba20a8.png";